/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React, { useMemo } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { helper } from '@tripian/model';
import ReactSelect, { InputActionMeta, SingleValue, MultiValue, MultiValueProps, components, GroupBase } from 'react-select';
import { RSelectOption } from '../base/RSelect/RSelect';
import { User } from '../base/Svg/Icons';
import classes from './CompanionSelect.scss';

interface ICompanionSelect {
  options: RSelectOption[];
  selectedOptionValues: string[];
  onSelectedOptionChange: (selectedOptions: RSelectOption[]) => void;
  onInputChange?: (newValue: string, actionMeta: InputActionMeta) => void;
  placeHolder?: string;
  disabled?: boolean;
  onFocus?: () => void;
  onBlur?: () => void;
}

const CompanionSelect: React.FC<ICompanionSelect> = ({ options, selectedOptionValues, onSelectedOptionChange, onInputChange, placeHolder = 'Please select', disabled = false, onFocus, onBlur }) => {
  const selectedOptions = useMemo(() => options.filter((option) => selectedOptionValues.includes(option.value)), [selectedOptionValues, options]);

  const handleChange = (newSelectedOptions: MultiValue<RSelectOption> | SingleValue<RSelectOption>) => {
    onSelectedOptionChange(newSelectedOptions as RSelectOption[]);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const customFilter = (option: { label: string; value: string; data: any }, searchText: string) => helper.toEngChars(option.label).toLowerCase().includes(helper.toEngChars(searchText).toLowerCase());

  const noOptionsMessage = (obj: { inputValue: string }) => {
    if (obj.inputValue.length > 2) {
      return <span>No Option Selected.</span>;
    }
    return null;
  };

  const formatOptionLabel = (option: RSelectOption) => (
    <>
      {option.label && (
        <div className={classes.optionLabel}>
          <User size="1.5rem" />
          <div className={classes.optionLabelText}>
            <div>{option.label}</div>
          </div>
        </div>
      )}
    </>
  );

  const CustomMultiValue: React.FC<MultiValueProps<RSelectOption, true, GroupBase<RSelectOption>>> = (props) => {
    const { data, selectProps } = props;
    const selectedValues = selectProps.value as RSelectOption[]; // doğrudan value kullanıyoruz
    const maxVisible = 2;

    const currentIndex = selectedValues.findIndex((val) => val.value === data.value);
    const hiddenCount = selectedValues.length - maxVisible;

    if (currentIndex < maxVisible) {
      return <components.MultiValue {...props} />;
    }

    if (currentIndex === maxVisible) {
      return <div style={{ padding: '0 8px', display: 'flex', alignItems: 'center' }}>+{hiddenCount} more</div>;
    }

    return null;
  };

  return (
    <>
      <ReactSelect
        isMulti
        options={options}
        value={selectedOptions}
        onChange={handleChange}
        onInputChange={onInputChange}
        filterOption={customFilter}
        placeholder={placeHolder}
        className="companionSelect"
        classNamePrefix="companionSelect"
        isDisabled={disabled}
        isClearable={false}
        // components={{ MultiValue: CustomMultiValue }}
        formatOptionLabel={formatOptionLabel}
        noOptionsMessage={noOptionsMessage}
        onFocus={() => onFocus && onFocus()}
        onBlur={() => onBlur && onBlur()}
      />
    </>
  );
};

export default CompanionSelect;
